import React from "react";
import { tokens } from "@blurb/codex-react";
import { createStyles, Skeleton } from "@mantine/core";

const useStyles = createStyles({
  skeletonField: {
    flex: "1 0 0",
    minWidth: 0,
  },
});

export const SkeletonField: React.FC = () => {
  const { classes } = useStyles();
  return (
    <div className={classes.skeletonField}>
      <Skeleton height={14} width={100} mb={tokens.spacing[1]} />
      <Skeleton height={16} width={160} />
    </div>
  );
};
